import Vue from 'vue'

Vue.filter('formatDate', function (date, type) {
  if (date !== '0') {
    if (date === '' || date === undefined || date === null) {
      return '--'
    }
  }
  let dateTime = '格式化失败'
  let getDate = date
  if (!(getDate instanceof Date)) {
    getDate = new Date(date)
  }
  let year = getDate.getFullYear()
  let month = getDate.getMonth() + 1
  let day = getDate.getDate()
  if (type === 'yyyy-MM-dd') {
    dateTime = year + '-' + addZero(month) + '-' + addZero(day)
  } else if (type === 'yyyy-M-d') {
    dateTime = year + '-' + month + '-' + day
  } else if (type === 'yyyy-M-d hh:mm week') {
    let hours = getDate.getHours()
    let minutes = getDate.getMinutes()
    const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    dateTime = year + '-' + addZero(month) + '-' + addZero(day) +
      ' ' + addZero(hours) + ':' + addZero(minutes) + ' ' + weeks[getDate.getDay()]
  } else if (type === 'M-d hh:mm') {
    let hours = getDate.getHours()
    let minutes = getDate.getMinutes()
    dateTime = addZero(month) + '-' + addZero(day) +' ' + addZero(hours) + ':' + addZero(minutes)
  } else {
    let hours = getDate.getHours()
    let minutes = getDate.getMinutes()
    let seconds = getDate.getSeconds()
    dateTime = year + '-' + addZero(month) + '-' + addZero(day) +
      ' ' + addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds)
  }
  return dateTime
})

function addZero(val) {
  if (val < 10) {
    return '0' + val
  } else {
    return val
  }
}

Vue.filter('fileIcon', function (fileExtension) {
  if (fileExtension === 'paper' || fileExtension === 'pic') return fileExtension
  return getFileIcon(fileExtension)
})

Vue.filter('fileSizeName', function (value) {
  if (value === null || value === '' || value === 0) {
    return '--'
  }
  let unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let index = 0
  let srcsize = parseFloat(value)
  index = Math.floor(Math.log(srcsize) / Math.log(1024))
  let size = srcsize / Math.pow(1024, index)
  size = size.toFixed(2)// 保留的小数位数
  let sIndex = size.indexOf('.00')
  if (sIndex !== -1) {
    size = size.substring(0, sIndex)
  }
  return size + unitArr[index]
})

Vue.filter('removePointZero', function (value, fixValue = 2) {
  if (value) {
    return testPointZero(value, fixValue)
  }
  return '0'
})


Vue.filter('shortTitle', function (title, max) {
  if (title && title.length > max) {
    return title.substring(0, max) + '...'
  } else {
    return title
  }
})

function testPointZero (value, fixValue = 2) {
  const target = parseFloat(value).toFixed(fixValue)
  if (target.indexOf('.') === -1) return value
  const values = target.split('.')
  let num = parseInt(values[1]) // 看看小数的整型
  if (num > 10 || num === 0) { // 将小数如9.10、9.00中的0去掉
    num = values[1].replace('0', '').replace('0', '') // 9.00时，num的长度为0
  } else {
    num = values[1] // 保留 9.01的01情况
  }
  if (num.length > 0) {
    return values[0] + '.' + num
  } else {
    return values[0]
  }
}


function getFileIcon(fileExtension) {
  if (!fileExtension) return 'other'
  switch (fileExtension) {
    case 'doc':
    case 'docx':
    case 'rtf':
      return 'doc'
    case 'ppt':
    case 'pptx':
      return 'ppt'
    case 'xls':
    case 'xlsx':
      return 'xls'
    case 'pdf':
      return 'pdf'
    case 'swf':
    case 'mp4':
    case 'flv':
    case 'avi':
    case 'rm':
    case 'mpg':
    case 'mpeg':
    case 'rmvb':
    case 'wmv':
      return 'flv'
    case 'mp3':
    case 'wav':
    case 'wma':
    case 'mid':
      return 'mp3'
    case 'jpg':
    case 'gif':
    case 'png':
    case 'jpeg':
      return 'pic'
    case 'rar':
    case 'zip':
      return 'rar'
    case 'paper':
    case 'question':
    case 'basket':
      return 'paper'
    default:
      return 'other'
  }
}
